// import ScrollAnimation from './ScrollAnimation'
import ScrollViewTrigger from './ScrollViewTrigger'
import AnimationJaPc from './AnimationJaPc'
import AnimationJaSp from './AnimationJaSp'
import AnimationEnPc from './AnimationEnPc'
import AnimationEnSp from './AnimationEnSp'

export default class {
  constructor() {
    this.dom = {};
    this.dom.ScrollAnimation = null;
    this.dom.ScrollViewTrigger = null;

    this.lang = null;

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    this.dom.ScrollViewTrigger = document.querySelector('[data-trigger="svt"]');
    if (this.dom.ScrollViewTrigger) new ScrollViewTrigger(this.dom.ScrollViewTrigger);

    this.dom.ScrollAnimation = document.querySelector('[data-js="scroll-animation"]');
    if (this.dom.ScrollAnimation) {
      this.lang = this.dom.ScrollAnimation.dataset.lang;
      // ブレイクポイントの瞬間に発火
      this.mql.addListener(this.checkBreakPoint);
      // 初回チェック
      this.checkBreakPoint(this.mql);
    }
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      if (this.lang === 'ja') {
        new AnimationJaSp(this.dom.ScrollAnimation);
      } else {
        new AnimationEnSp(this.dom.ScrollAnimation);
      }
      return;
    } else {
      // console.log('pc');
      if (this.lang === 'ja') {
        new AnimationJaPc(this.dom.ScrollAnimation);
      } else {
        new AnimationEnPc(this.dom.ScrollAnimation);
      }
      return;
		}
	}
}
